import Client from "../client";
import Resource from "../resources/resource";

class ConfigurationRepository<TResource extends Resource> {
    protected client: Client;
    private configurationLinkName: string;

    constructor(configurationLinkName: string, client: Client) {
        this.configurationLinkName = configurationLinkName;
        this.client = client;
    }
    get(): Promise<TResource> {
        return this.client.get<TResource>(this.client.getRootDocument().Links[this.configurationLinkName]);
    }

    modify(resource: TResource): Promise<TResource> {
        return this.client.update<TResource>(resource.Links["Self"], resource);
    }
}

export default ConfigurationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/configurationRepository.ts